<template>
    <div style="min-height: calc(100vh - 158px);" class="card">
        <div style="background: #DBE7F2" class="p-2">
            <TitleButton
                btnTitle="Add New"
                :showBtn="false"
                :showAddNew="true"
                title="Imported Cash And Bank List"
                @onClickAddNewButton="onClickAddNewButton"
            />
            <div class="row match-height mt-1">
                <div class="col-12">
                    <DateQuerySetter
                        @onClickGo="getJournals"
                    />
                </div>
            </div>
        </div>

        <ListTable @onDelete="onDelete" :journals="journals"/>
        <div class="mb-2"></div>
        <div class="px-2 position-absolute bottom-0">
            <Pagination
                :offset="offset"
                @onPageChange="onPageChange"
                ref="pagination"
            />
        </div>
        <Loader v-if="loading"/>
        
    </div>
</template>

<script>
import handleJournal from '@/services/modules/journal'
import { inject } from 'vue'
import {mapMutations} from 'vuex'
import TitleButton from '@/components/atom/TitleButton'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import ListTable from '@/components/molecule/cash-bank-import/ListTable'
import Pagination from '@/components/atom/Pagination'
import Loader from '@/components/atom/LoaderComponent'

export default {
    name: 'ImportCashBankTransactionList',

    data: () => ({
        offset: 20,
        journals: []
    }),

    components: {
        TitleButton,
        DateQuerySetter,
        ListTable,
        Pagination,
        Loader
    },

    computed: {
        companyId() {
            return this.$route.params.companyId
        },
        start() {
            return this.$route.query.start
        },
        end() {
            return this.$route.query.end
        },
        page() {
            return this.$route.query.page
        },
    },

    methods: {
        ...mapMutations({
            setPaginationData: 'setPaginationData',
            resetPagination: 'resetPagination'
        }),

        onClickAddNewButton() {
            this.$router.push({name: 'import-cash-bank-transaction',
                params: {
                    companyId: this.$route.params.companyId,
                    moduleId: this.$route.params.moduleId,
                    menuId: this.$route.params.menuId,
                    pageId: this.$route.params.pageId
                },
                query: {
                    start: this.start,
                    end: this.end
                }
            })
        },

        async onPageChange(page) {
          let routeQuery = Object.assign({}, this.$route.query)
          routeQuery.page = page

          await this.$router.push({
            path: this.$route.path,
            query: routeQuery
          })

          await this.getJournals()
        },

        setPagination(data) {
            this.setPaginationData({
                records: data.total,
                perPage: data.per_page,
                currentPage: data.current_page,
            })
        },

        async getJournals() {
            const query = this.getQuery()
            try {
                this.loading = true
                let res = await this.fetchUploadedJournals(query)
                if(!res.status) {
                  this.resetPagination()
                  this.showError(res.message)
                  return;
                }

                this.journals = res.data.data
                if(res.data.data.length > 0) {
                  this.setPagination(res.data)
                }
            } catch (err) {
              this.showError(err.response.message)
            } finally {
                this.loading = false
            }
        },

        onDelete(id) {
            this.loading = true
            this.removeUploaded(id, this.companyId)
            .then(res => {
                this.loading = false
                if(res.status) {
                  this.showSuccess('Delete success')
                  this.getJournals()
                }
            })
            .catch(err => {
                this.showError('Something went wrong!')
            })
        },

        getQuery () {
            let query = '?company_id=' + this.companyId
            if(!this.start && !this.end) return query
            if(this.start) query += '&start_date='+this.start
            if(this.end) query += '&end_date='+this.end
            query += '&offset='+this.offset
            if(this.page) query += '&page='+this.page
            query += '&cash_and_bank_type=cash_and_bank_transaction'
            return query
        },
    },

    setup() {
        const showError =  inject('showError');
        const showSuccess =  inject('showSuccess');

        const {
            fetchUploadedJournals,
            removeUploaded,
            loading
        } = handleJournal()

        return {
            fetchUploadedJournals,
            removeUploaded,
            loading,
            showError,
            showSuccess
        }
    },

    mounted() {
        this.getJournals()
    }
}
</script>
